import { EntityId, EntitySelectSubEntity } from '@factorialco/f0-react/dist/experimental'
import { EntitySelectEntity } from '@factorialco/f0-react/dist/experimental'

export function flatSelection(selection: EntitySelectEntity[]): EntitySelectSubEntity[] {
  const allSubItems = selection.flatMap((entity) => entity.subItems ?? [])

  const seenIds = new Set<EntityId>()

  return allSubItems.filter((sub) => {
    if (seenIds.has(sub.subId)) {
      return false
    }
    seenIds.add(sub.subId)
    return true
  })
}
